import React from 'react';
import { ExternalLink } from 'lucide-react';
import './GoogleRating.css';

interface GoogleRatingProps {
  rating: number;
  reviewCount: number;
  googlePlacesId: string;
  showProvider?: boolean | true;
  showLink?: boolean | true;
}

const GoogleRating: React.FC<GoogleRatingProps> = ({ 
  rating, 
  reviewCount, 
  googlePlacesId,
  showProvider,
  showLink
}) => {
  const handleClick = () => {
    const googleMapsUrl = `https://www.google.com/maps/place/?q=place_id:${googlePlacesId}`;
    window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
  };

  const StarIcon = ({ filled, halfFilled }: { filled: boolean; halfFilled: boolean }) => {
    const clipId = `half-star-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="star-svg"
      >
        <defs>
          {halfFilled && (
            <clipPath id={clipId}>
              <rect x="0" y="0" width="12" height="24" />
            </clipPath>
          )}
        </defs>
        {/* Always draw the outline */}
        <path
          d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          fill="none"
          stroke="currentColor"
        />
        {/* Draw the filled portion */}
        {filled && (
          <path
            d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            fill="currentColor"
          />
        )}
        {halfFilled && (
          <path
            d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            fill="currentColor"
            clipPath={`url(#${clipId})`}
          />
        )}
      </svg>
    );
  };

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, index) => {
      const starRating = index + 1;
      const isHalfStar = rating >= index + 0.5 && rating < starRating;
      const isFullStar = rating >= starRating;
      
      return (
        <StarIcon
          key={index}
          filled={isFullStar}
          halfFilled={isHalfStar}
        />
      );
    });
  };

  return (
    <div 
      className="google-rating"
      onClick={handleClick}
    >
      <div className="google-rating-stars">
        {renderStars()} 
        <span className="google-rating-score">{rating.toFixed(1)} ({reviewCount})</span>
      </div>
      {showProvider && (
      <div className="google-rating-attribution">
        <img 
            src="/images/google-logo.png" 
            alt="Google" 
            className="google-logo-image"
        />
        <span className="google-rating-text">Ratings provided by Google</span>
      </div>
      )}
      

    </div>
  );
};

export default GoogleRating;
